export type OptionalEnvBooleanString = 'true' | 'false' | undefined;

/**
 * Parses an optional env string (`true` / `false`) into a boolean override.
 * Returns `null` when unset so callers can fall back to Flipt.
 */
export const parseOptionalEnvBoolean = (
  value: OptionalEnvBooleanString,
): boolean | null => {
  if (value === 'true') {
    return true;
  }

  if (value === 'false') {
    return false;
  }

  return null;
};
